import ReactGA from 'react-ga'
import posthog from 'posthog-js'

import { LOCALSTORAGE_TOKENS, USER_ROLES, gaDimensions } from '../constants'

/**
 * Resolve os papéis (papel_usuario) como array de strings.
 * O papel é marcado explicitamente conforme a tela/fluxo de entrada
 * (['aluno'] no login principal, ['avalista'] no provi-sign).
 * Fallback: ['aluno'].
 *
 * @param {string[]} [roles]
 * @returns {string[]}
 */
const resolveRoles = roles => {
  if (Array.isArray(roles) && roles.length) return roles

  return [USER_ROLES.aluno]
}

export const identify = ({ CreditRequestId, UserId, email, partnerSlug }) => {
  window.smartlook &&
    window.smartlook('identify', UserId, {
      CreditRequestId,
      UserId,
      email
    })

  // eslint-disable-next-line import/no-named-as-default-member
  ReactGA.set({
    [gaDimensions.userId]: UserId,
    [gaDimensions.partnerSlug]: partnerSlug,
    [gaDimensions.creditRequestId]: CreditRequestId
  })

  // O posthog.identify (person) NÃO roda aqui: este identify() é disparado a cada
  // navegação (history.listen) e no boot. O person identify roda apenas na primeira
  // entrada na aplicação, via identifyPerson() no validate-token.
  // A associação ao grupo (posthog.group('partner', 'principiapay_<PartnerId>', ...))
  // é feita no selectCrid, onde o PartnerId é obtido via getPartnerInfo.
}

/**
 * posthog.identify (person) — deve ser chamado apenas na PRIMEIRA entrada na
 * aplicação (validate-token), não a cada navegação.
 *
 * @param {{ CreditRequestId?: number|string, UserId: number|string, email: string, roles?: string[] }} payload
 */
export const identifyPerson = ({ CreditRequestId, UserId, email, roles }) => {
  // Nome é persistido no localStorage durante a validação do token (validate-token).
  const name = localStorage.getItem(LOCALSTORAGE_TOKENS.name) || undefined
  const personProperties = {
    papel_usuario: resolveRoles(roles),
    principiapay_id: String(UserId),
    email,
    crid: CreditRequestId
  }
  if (name) personProperties.name = name

  posthog.identify(String(UserId), personProperties)
}

const getStoredIdentity = () => {
  const UserId = localStorage.getItem(LOCALSTORAGE_TOKENS.userId)
  const email = localStorage.getItem(LOCALSTORAGE_TOKENS.email)
  const partnerSlug = localStorage.getItem(LOCALSTORAGE_TOKENS.partnerSlug)

  return {
    UserId,
    email,
    partnerSlug
  }
}

export const identifyFromStoredIdentity = () => {
  const payload = getStoredIdentity()
  identify(payload)
}
